import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./toast-message.scss";
import { ToastContainer, toast, Zoom } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import successImg from "assets/images/v2/Success-Check.svg";
import ToastCloseButton from "./ToastCloseButton";

interface ToastMessageProps {
  header?: string;
  message: string;
  timeout?: number;
  state: "success" | "error" | "info" | "warning";
  position?:
    | "top-left"
    | "top-right"
    | "top-center"
    | "bottom-left"
    | "bottom-right"
    | "bottom-center";
}

const ToastMessage = ({
  header,
  message,
  timeout = 1000,
  state,
  position = "top-left",
}: ToastMessageProps) => {
  const ToastContent = (
    <div className="toast-content">
      {header && <p className="toast-header">{header}</p>}
      <p className="toast-content">{message}</p>
    </div>
  );
  const errIcon = <FontAwesomeIcon icon={solid("exclamation-triangle")} />;
  const getToastIcon = () => {
  if (state === "success") {
    return <img src={successImg} className="toast-success-icon" alt="success" />;
  }
  if (state === "error") {
    return errIcon;
  }
  return undefined;
  };

  const showToast = () => {
    const toastId = message+state;
    toast(ToastContent, {
      theme: "colored",
      type: state,
      autoClose: timeout, 
      closeButton: ToastCloseButton,
      hideProgressBar: true,
      transition: Zoom,
      position: position,
      toastId: toastId,
      icon: getToastIcon()
    });
  };

  showToast();
  return <ToastContainer />;
};

export default ToastMessage;
